import React from 'react';
import LayoutContentWrapper from "../LayoutContentWrapper/LayoutContentWrapper";
import style from "./Footer.module.css";
import {CopyrightFooter} from "./CopyrightFooter/CopyrightFooter";
import {Navigation} from "../Header/Navigation/Navigation";
import {FooterLogo} from "./FooterLogo/FooterLogo";

const Footer = () => {

    return (
        <footer className={style.footer}>
            <LayoutContentWrapper>
                <div className={style.footerNavWrapper}>
                    <FooterLogo/>
                    <Navigation key={'footer'}/>
                </div>
            </LayoutContentWrapper>
            <CopyrightFooter/>
        </footer>

    );
};

export default Footer;